import Vue from 'vue';
import axios from 'axios';
import {PiniaVuePlugin} from 'pinia';

/* Plugins */
import BootstrapVue from 'bootstrap-vue';
import MilestonesUiKit from '@sellers-shield-home-protection/ss-ui-kit/src';
import {SelectConfig} from '@sellers-shield-home-protection/ss-ui-kit/src/components/CustomSelect/CustomSelect';
import {Engine} from '@sellers-shield-home-protection/ss-core-js';
import Vue2Filters from 'vue2-filters';

Vue.use(BootstrapVue);
Vue.use(Vue2Filters);
Vue.use(MilestonesUiKit);
Vue.use(PiniaVuePlugin);


/*import VueClipboards from 'vue-clipboards';
Vue.use(VueClipboards);*/

SelectConfig.set({
    xhrLib: axios,
    apiHost: window.env.MILESTONES_API_HOST,
    apiPrefix: window.env.MILESTONES_API_PREFIX,
    apiVersion: window.env.MILESTONES_API_VERSION,
});


Engine.config({
    xhrLib: axios,
    debug: true,
    apiHost: window.env.MILESTONES_API_HOST,
    apiPrefix: window.env.MILESTONES_API_PREFIX,
    apiVersion: window.env.MILESTONES_API_VERSION,
});

/* federated modules component imports */
Vue.component('ThirdPartyBranding', async () => await import('integrations/3party-branding'));


/* providers */

Vue.prototype.$bus = new Vue();


export {};
